class ToggleCardTagsVisibility {
  cards = undefined;
  constructor(cards) {
    this.cards = cards;
    this.init();
    window.addEventListener('resize', function () { this.init() }.bind(this), true);
  }

  init() {
    Array.from(this.cards).forEach(function (card) {
      this.toggleTagsVisiblity(card);
    }.bind(this));
  }

  toggleTagsVisiblity(card) {
    const container = card.getElementsByClassName('horizontal-tags-list')[0];
    const tags = container.querySelectorAll('li');
    Array.from(tags).forEach(function (tag) {
      if ((tag.offsetLeft + tag.offsetWidth) > (container.offsetWidth + 15)) {
        tag.style.display = 'none';
      }
      else {
        tag.style.display = null;
      }
    });
  }
}
export default ToggleCardTagsVisibility;
